<template>
  <div class="user-drafts_udf">

    <page-header>
      <nav-inner :use-user-links="true"/>
    </page-header>

    <div class="page-container_pcr">
      <router-link
        class="help-link"
        :to="{ path: '/help/23'}"
        target="_blank">
         Подробнее о черновиках в разделе Помощь
      </router-link>

      <div v-if="drafts.length > 0">

        <div
          v-for="(d, i) in drafts"
          :key="`draft-${i}`"
          class="object-teaser_otr"
          :class="{ [`otr_${d.draft_type}`]: true, [curTheme]: true }">

            <div class="otr_wrap">

            <img
              v-if="d"
              :src="`/static/grx/icons/objects/${d.draft_type}.svg`"
              class="otr_icon">

            <h2 v-if="d" class="otr_title">{{ d.draft_title }}</h2>

            <div class="otr_info">

              <el-tooltip
                v-if="d"
                :content="type(d.draft_type)"
                placement="top"
                :enterable="false"
                :open-delay="500">
                <div class="otr_info-el otr_type">
                  {{ type(d.draft_type) }}
                </div>
              </el-tooltip>

              <el-tooltip
                v-if="d.created_at"
                placement="top"
                :enterable="false"
                :open-delay="openDelay">
                <div slot="content">
                  <span v-html="createdTimePopup(d.created_at)"></span>
                </div>
                <div class="otr_info-el otr_created-time">
                  {{ formatTime(d.created_at) }}
                </div>
              </el-tooltip>

            </div>

              <div class="otr_object-stat_oos">

                <el-dropdown
                  :hide-on-click="true"
                  :trigger="isMobile ? 'click' : 'hover'"
                  @command="draftsActions">

                  <span class="el-dropdown-link"><i class="el-icon-more"></i></span>

                  <el-dropdown-menu slot="dropdown" class="el-dropdown--no-links">

                    <el-dropdown-item
                      :command="{ action: 'saveDraft', index: i }">
                        Продолжить депонирование</el-dropdown-item>

                    <el-dropdown-item
                      :command="{ action: 'deleteDraft', index: i }">
                      Удалить черновик</el-dropdown-item>

                  </el-dropdown-menu>

                </el-dropdown>

              </div>

          </div>

        </div>
      </div>

      <div v-else>
        <div class="no-results">
          На данный момент Вы не создали ни одного черновика.
          <div class="depo-msg_dmg dmg_btn dmg_themable"
               @click="$router.push({ path: '/objects/add' })">
            <div class="dmg_draft"></div>
            <div class="dmg_plus"></div>
            <div class="dmg_text">
              Черновики предназначены для хранения промежуточных версий данных в
              процессе депонирования цифровых объектов авторского права.
            </div>
          </div>
        </div>
      </div>

    </div>

    <page-footer/>

  </div>
</template>

<script>
import axios from 'axios';
import PageHeader from '../PageHeader';
import PageFooter from '../PageFooter';
import NavInner from '../NavInner';

export default {

  components: { PageHeader, PageFooter, NavInner },

  data() {
    return {
      drafts: [],
      openDelay: 500,
    };
  },

  created() {
    this.fetchData();
  },

  computed: {

    curTheme() {
      return this.$store.getters['theme/curTheme'];
    },

    isMobile() {
      return window.innerWidth <= 830;
    },

  },

  methods: {

    type(draftType) {
      let title = '';
      const type = this.$store.getters['types/getType'](draftType);
      if (type) {
        title = type.Title;
      }
      return title;
    },

    formatTime(timestamp) {
      let time = '';
      if (timestamp) {
        const d = new Date(timestamp * 1000);
        const year = d.getFullYear();

        let month = d.getMonth() + 1;
        if (month < 10) month = `0${month}`;

        let date = d.getDate();
        if (date < 10) date = `0${date}`;

        let hours = d.getHours();
        if (hours < 10) hours = `0${hours}`;

        let minutes = d.getMinutes();
        if (minutes < 10) minutes = `0${minutes}`;

        time = `${date}.${month}.${year} ${hours}:${minutes}`;
      }
      return time;
    },

    createdTimePopup(timestamp) {
      return '<span class="tooltip-title">Создан:</span>' +
        `<br>${this.formatTime(timestamp)}`;
    },

    fetchData() {
      axios.get('drafts').then((r) => {
        this.drafts = r.data;
      }).catch((err) => {
        this.$message.closeAll();
        this.$message(err.response.data);
      });
    },

    draftsActions(command) {
      this[command.action](command.index);
    },

    saveDraft(index) {
      const draft = JSON.parse(this.drafts[index].draft_values);
      this.$store.commit('drafts/setDraft', draft);
      this.$router.push({ path: '/objects/add' });
    },

    deleteDraft(index) {
      axios.delete(`drafts?draft_type=${this.drafts[index].draft_type}`).then((r) => {
        this.$message.closeAll();
        this.$message(r.data);
        this.drafts.splice(index, 1);
      }).catch((err) => {
        this.$message.closeAll();
        this.$message(err.response.data);
      });
    },

  },

};
</script>

<style lang="scss">
.user-drafts_udf {

}
</style>



// WEBPACK FOOTER //
// src/components/layouts/UserDrafts.vue